import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { User } from '../shared/interfaces';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class UserResolver implements Resolve<User> {
  constructor(
    private userService: UserService,
    private router: Router,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const param = route.paramMap.get('id');

    if (param === 'add') {
      return null;
    }

    try {
      const id = parseInt(param, 10);
      return await this.userService.get(id);
    } catch (e) {
      this.router.navigate(['/user/admins']);
      return null;
    }
  }
}
